<section class="benefits-section w-full">
  <div class="benefits-header relative overflow-hidden py-3 px-3 mb-4 md:mb-5">
    <div class="container-layout">
      <h2 class="benefits-title relative z-1 m-0 text-center text-white font-bold line-height-3">
        Tudo que você precisa em um só lugar
      </h2>
    </div>
  </div>

  <div class="container-layout">
    <div class="flex flex-wrap justify-content-center align-items-stretch gap-3 md:gap-4">
      @for (benefit of benefits(); track benefit.id) {
        <div
          class="benefit-card relative overflow-hidden flex flex-column align-items-center text-center gap-3 p-3 bg-white border-round-xl"
          [style.animation-delay]="benefit.delay"
          [style.--benefit-color]="benefit.color"
        >
          <div
            class="benefit-icon relative z-2 flex align-items-center justify-content-center flex-shrink-0 border-circle"
            [style.background]="benefit.gradient"
          >
            <i [class]="benefit.icon" class="text-white text-xl"></i>
          </div>

          <div class="relative z-2 flex flex-column align-items-center flex-1 gap-1">
            <h3 class="benefit-title m-0 font-bold line-height-3 text-sm md:text-base">
              {{ benefit.title }}
            </h3>
            <p class="benefit-description m-0 line-height-3 text-xs md:text-sm">
              {{ benefit.description }}
            </p>

            @if (benefit.badge) {
              <p-tag
                [value]="benefit.badge"
                icon="pi pi-star-fill"
                [rounded]="true"
                [style.background]="benefit.gradient"
                styleClass="mt-2 text-white"
              />
            }
          </div>
        </div>
      }
    </div>
  </div>
</section>
